import { showDrawer } from './views.ts';
import { showFirstRun } from './onboarding.ts';
import { getClock } from './clock.ts';
import { sweepExpired, meta } from './store.ts';
import { initAnalytics } from './analytics.ts';

async function boot(): Promise<void> {
  const clock = await getClock();
  await sweepExpired(clock.now());
  // Loads the tag with consent defaulted to denied, then applies a stored answer.
  // Nothing is stored and no identifier is set until someone opts in.
  await initAnalytics();

  if (!(await meta<boolean>('onboarded'))) {
    // Three cards, then straight into the viewfinder — the promise is stated in
    // plain words before anyone is asked to point a camera at anything.
    await showFirstRun(() => void showDrawer());
  } else {
    await showDrawer();
  }

  // Anything that expired while the app was closed goes on return. This is the
  // web platform's honest limit: nothing runs in the background, so the guarantee
  // is that an expired photo is never readable, and the bytes go on next open.
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') void showDrawer();
  });

  if ('serviceWorker' in navigator) {
    // When a new worker takes over, the page is still running the old code it was
    // loaded with. Reload once so an update actually reaches the person using it.
    let reloading = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloading) return;
      reloading = true;
      location.reload();
    });
    navigator.serviceWorker.register('sw.js').catch(() => {});
  }
  if (navigator.storage?.persist) {
    // Asking matters: evicted storage would delete a photo before its time.
    void navigator.storage.persist();
  }
}

void boot();
